<template>
    <div>
        <Gl_leftmenu />
        <Gl_header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <Winaspect ref="winaspect" @close="show_mklist(list_id)" />
            <div class="content-header">
                <Gl_backbutton />
                Оценочная ведомость {{ marking_list.name }}
            </div>
            <div class="content-inner">
                <table>
                    <tr>
                        <th>Наименование аспекта</th>
                        <th>Вес аспекта</th>
                        <th>Пояснение к оценке</th>
                        <th></th>
                    </tr>
                    <tr v-for="aspect in aspects_list" :key="aspect.aspect_id">
                        <td>{{ aspect.name }}</td>
                        <td>{{ aspect.value }}</td>
                        <td>{{ aspect.description }}</td>
                        <td>
                            <div class="btn_for_table_delete buttons_inline" @click="delete_aspect(aspect.aspect_in_mklists_id)">Удалить</div>
                        </td>
                    </tr>
                </table>
                <br>
                <div class="btn_add" @click="show_skills_aspects()">Добавить аспект</div>
            </div>
        </div>
    </div>
</template>

<script>
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'
import Winaspect from '@/components/windows/win_aspects.vue'

export default {
    name: 'Markinglist',
    props: ['list_id'],
    components: {
        Success, Error, Winaspect 
    },
    mixins: [
        require('../../mixins/markinglist/markinglistMixins.vue')
    ],
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            marking_list: {},
            aspects_list: {}
        }
    },
    methods: {
        show_skills_aspects() {
            this.$refs.winaspect.corpstandart_id = this.marking_list.corpstandart_id
            this.$refs.winaspect.mk_list_id = this.marking_list.id
            this.$refs.winaspect.isWinAspect = true
            this.$refs.winaspect.skills_aspects()
        }
    },
    created() {
        this.show_mklist(this.list_id)
    }
}
</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>